import React from 'react';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import HoverTooltip from '@Components/HoverTooltip';
import { TooltipConstants } from '@Components/Tooltip';
import { ButtonWithIcon } from '@els/els-react--button';

import './PreferencesTooltip.scss';

function PreferencesTooltip({ content, label, name }) {
  return (
    <div className="preferences-tooltip">
      <div className="preferences-tooltip__label">{label}</div>
      <HoverTooltip
        id={TooltipConstants.ids.GlobalHover}
        tooltip={ReactDOMServer.renderToString(
          <ul className="info-tooltip-content-list">
            {content.map((contentItem, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={`preferences-tooltip-${name}-${index}`} className="info-tooltip-content-list-item bullet-dot">
                {contentItem}
              </li>
            ))}
          </ul>
        )}>
        <ButtonWithIcon
          type="link"
          sprite="InformationOutlineCircle"
          iconOnly
          className={`info-tooltip e2e-${name}-tooltip`}
          onClick={() => {}}>
          {label}
        </ButtonWithIcon>
      </HoverTooltip>
      <div />
    </div>
  );
}

PreferencesTooltip.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  content: PropTypes.arrayOf(PropTypes.node),
};

export default PreferencesTooltip;
